import { Component, OnDestroy, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color } from 'ng2-charts-x';

import {
  BackendService,
  FieldMapItem,
  FieldStructure,
  FieldTypeEnum,
  NotificationService,
} from 'beyond-util';

import { ExportService } from '../../../services/export.service';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { BudzetService } from '../../../services/budzet.service';
import { RealizacijaEnum } from './realizacija.enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnumService } from '../../../services/enum.service';
import moment = require('moment');
import { RGatewayRequest } from '../../../models/RGatewayRequest';
import { ReportService } from '../../../services/report.service';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { RequestTypeEnum } from '../../../enums/request-type.enum';

@Component({
  selector: 'app-realizacija-ugovora',
  templateUrl: './realizacija-ugovora.component.html',
  styleUrls: ['./realizacija-ugovora.component.scss'],
})
export class RealizacijaUgovoraComponent extends IzvestajBaseComponent
  implements OnInit, OnDestroy {
  public RealizacijaEnum = RealizacijaEnum;
  public activeTab: RealizacijaEnum = RealizacijaEnum.UkupnaRealizacija;
  public ukupnoFieldStructure: FieldStructure;
  public ugovorFieldStructure: FieldStructure;
  public klijentFieldStructure: FieldStructure;
  public podugovorFieldStructure: FieldStructure;

  public ukupnoReport: any = {};
  public ugovorReport: any = {};
  public klijentReport: any = {};
  public podugovorReport: any = {};

  public lineChartColorsUgovor: Color[] = [
    {
      borderColor: '#0371BC',
      backgroundColor: '#0371BC',
      borderWidth: 1,
    },
    {
      borderColor: '#33414E',
      backgroundColor: '#33414E',
      borderWidth: 1,
    },
    {
      borderColor: '#EE442E',
      backgroundColor: '#EE442E',
      borderWidth: 1,
    },
  ];
  public barChartColorsUgovor: Color[] = [
    {
      borderColor: '#0371BC',
      backgroundColor: '#0371BC',
      borderWidth: 1,
    },
    {
      borderColor: '#33414E',
      backgroundColor: '#33414E',
      borderWidth: 1,
    },
  ];
  public lineChartColorsKlijent: Color[] = [
    {
      borderColor: '#33414E',
      backgroundColor: '#33414E',
      borderWidth: 1,
    },
    {
      borderColor: '#EE442E',
      backgroundColor: '#EE442E',
      borderWidth: 1,
    },
  ];
  public lineChartDataUgovor: ChartDataSets[] = [
    { data: [], label: 'Rezervacije kumulativno', fill: false, lineTension: 0 },
    { data: [], label: 'Realizacija kumulativno', fill: false, lineTension: 0 },
    {
      data: [],
      label: 'Budžet po ugovoru',
      fill: false,
      borderDash: [5, 5],
      lineTension: 0,
    },
  ];
  public lineChartDataPodugovor: ChartDataSets[] = [
    { data: [], label: 'Rezervacije kumulativno', fill: false, lineTension: 0 },
    { data: [], label: 'Realizacija kumulativno', fill: false, lineTension: 0 },
    {
      data: [],
      label: 'Budžet po podugovoru',
      fill: false,
      borderDash: [5, 5],
      lineTension: 0,
    },
  ];

  public realizacijaUkupnoKumulativno: ChartDataSets[] = [
    {
      data: [],
      label: 'Realizacija kumulativno RSD',
      fill: false,
      borderWidth: 1,
      lineTension: 0,
    },
    {
      data: [],
      label: 'Realizacija kumulativno EUR',
      fill: false,
      borderWidth: 1,
      lineTension: 0,
    },
    {
      data: [],
      label: 'Budžet po ugovorima',
      fill: false,
      borderDash: [5, 5],
      lineTension: 0,
    },
  ];

  public lineChartDataKlijent: ChartDataSets[] = [
    // {
    //   data: [],
    //   label: 'Realizacija kumulativno',
    //   fill: false,
    //   borderWidth: 1,
    //   lineTension: 0,
    // },
    // {
    //   data: [],
    //   label: 'Budžet po ugovorima',
    //   fill: false,
    //   borderDash: [5, 5],
    //   lineTension: 0,
    // },
  ];
  public lineChartOptions: ChartOptions & { annotation: any } = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            callback: (dataLabel, index) => {
              return this.decimalPipe.transform(dataLabel, '1.2-2');
            },
          },
        },
      ],
    },
  };
  public lineChartLegend = true;
  public lineChartType = 'line';

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            callback: (dataLabel, index) => {
              return this.decimalPipe.transform(dataLabel, '1.2-2');
            },
          },
        },
      ],
    },
  };
  public barChartType = 'bar';
  public barChartLegend = true;

  public barChartDataUgovor: ChartDataSets[] = [
    { data: [], label: 'Rezervacije', borderWidth: 1 },
    { data: [], label: 'Realizacija', borderWidth: 1 },
  ];
  public barChartDataPodugovor: ChartDataSets[] = [
    { data: [], label: 'Rezervacije', borderWidth: 1 },
    { data: [], label: 'Realizacija', borderWidth: 1 },
  ];
  public barChartDataKlijent: ChartDataSets[] = [
    { data: [], label: 'Realizovano po ugovoru', ugovorLabel: '', borderWidth: 1 },
  ];
  public lineChartDataKlijentRealizovano = [];
  public barChartDataKlijentRealizovano = [];
  public lineChartDataKlijentRealizovanoSum = [];
  public lineChartDataKlijentPriliv = [];
  public lineChartDataKlijentPrilivSum = [];
  public lineChartDataUgovorPriliv = [];
  public lineChartDataUgovorPrilivSum = [];
  public ugovori = [];

  public monthsLabels = [];
  public currenciesUkupno = ['', 'RSD', 'EUR'];
  public monthsLabelsUgovor = [];
  public monthsLabelsKlijent = [];
  public monthsLabelsPodugovor = [];
  public realizacijaPoUgovorimaRSD = [];
  public realizacijaPoUgovorimaEUR = [];
  public excelEntity = {
    RealizacijaUkupno : null,
    RealizacijaUgovora : null,
    RealizacijePoKlijentu : null,
    RealizacijaPodugovora : null
  };

  public months = [
    { no: '0', label: 'Jan' },
    { no: '1', label: 'Feb' },
    { no: '2', label: 'Mar' },
    { no: '3', label: 'Apr' },
    { no: '4', label: 'Maj' },
    { no: '5', label: 'Jun' },
    { no: '6', label: 'Jul' },
    { no: '7', label: 'Avg' },
    { no: '8', label: 'Sep' },
    { no: '9', label: 'Okt' },
    { no: '10', label: 'Nov' },
    { no: '11', label: 'Dec' },
  ];
  private fromMonth = 1;
  private toMonth = 12;
  public currencies = ['RSD', 'EUR'];
  public realizacijaPoUgovoruTitle = 'Izaberite ugovor za prikaz';
  public realizacijaPoKlijentuTitle = 'Izaberite klijenta za prikaz';
  public ukupnaRealizacijaTitle =
    'Ukupan priliv budžeta / Ukupno rezervisano / Ukupno realizovano (po svim ugovorima i klijentima)';
  public realizacijaPoPodugovoruTitle = 'Izaberite podugovor za prikaz';
  public ugovoreniBudzetRSD = 0;
  public rezervacijeRSD = 0;
  public realizacijeRSD = 0;
  public ugovoreniBudzetEUR = 0;
  public rezervacijeEUR = 0;
  public realizacijeEUR = 0;

  constructor(
    protected rtsBackendService: RtsBackendService,
    public backendService: BackendService,
    private budzetService: BudzetService,
    private exportService: ExportService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    private decimalPipe: DecimalPipe,
    private _spinner: NgxSpinnerService,
    private _enumService: EnumService
  ) {
    super(backendService);
    this.name = 'Realizacija ugovora';
  }

  ngOnInit() {
    setTimeout(() => {
      this._enumService.fetchAllNacinObracuna();
      super.ngOnInit();
      this.setToolbarOptions({ showPrint: false, showExport: false });
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  settingsLoadSingle() {
    this._spinner.show();
    this.report = {};

    const ukupnoSettings = this.rtsBackendService
    .fetchSettings(
      FormCode.MSBUDZET_IZV_UKUPNO,
      FormName.PregledProgama,
      EndpointTypes.SingleEntity
    ).toPromise();
    const ugovorSettings = this.rtsBackendService
      .fetchSettings(
        FormCode.MSBUDZET_IZV_UGOVOR,
        FormName.PregledProgama,
        EndpointTypes.SingleEntity
      ).toPromise();
     const klijentSettings = this.rtsBackendService
      .fetchSettings(
        FormCode.MSBUDZET_IZV_KLIJENT,
        FormName.PregledProgama,
        EndpointTypes.SingleEntity
      ).toPromise();
      const podugovorSettings = this.rtsBackendService
      .fetchSettings(
        FormCode.MSBUDZET_IZV_PODUGOVOR,
        FormName.PregledProgama,
        EndpointTypes.SingleEntity
      ).toPromise();
    Promise.all([ukupnoSettings, ugovorSettings, klijentSettings, podugovorSettings]).then(response => {
      // UKUPNO
        this.ukupnoFieldStructure = new FieldStructure(response[0].Settings, 'header');
        this.settingsData = response[0].Settings;
      // UGOVOR
      this.ugovorFieldStructure = new FieldStructure(response[1].Settings, 'header');
      this.ugovorFieldStructure.fieldList[0].relation.completerMainField = "BrojUgovora";
      this.ugovorFieldStructure.fieldList[0].relation.completerSecondField = "TipUgovoraId";
      this.ugovorFieldStructure.fieldList[0].relationKey.all[0] = "BrojUgovora";
      this.ugovorFieldStructure.fieldList[0].relationValue.all[0] = "TipUgovoraId";
      this.ugovorFieldStructure.fieldList[1].editable = false;
      this.ugovorFieldStructure.fieldList[2].editable = false;
      this.ugovorFieldStructure.fieldList[3].editable = false;
      this.settingsData = response[1].Settings;
      // KLIJENT
      this.klijentFieldStructure = new FieldStructure(response[2].Settings, 'header');
      this.settingsData = response[2].Settings;
      // PODUGOVOR
      this.podugovorFieldStructure = new FieldStructure(response[3].Settings, 'header');
      this.podugovorFieldStructure.fieldList[0].relation.completerMainField = "BrojUgovora";
      this.podugovorFieldStructure.fieldList[0].relation.completerSecondField = "TipUgovoraId";
      this.podugovorFieldStructure.fieldList[0].relationKey.all[0] = "BrojUgovora";
      this.podugovorFieldStructure.fieldList[0].relationValue.all[0] = "TipUgovoraId";
      this.podugovorFieldStructure.fieldList[1].editable = false;
      this.podugovorFieldStructure.fieldList[2].editable = false;
      this.podugovorFieldStructure.fieldList[3].editable = false;
      this.podugovorFieldStructure.fieldList[4].editable = false;
      this.togglePodugovor(false);
      this.settingsData = response[3].Settings;
        this._spinner.hide();
    });
  }

  onToolbarActionExport() {
    this.exportService.exportToExcel(
      this.tables,
      this.report,
      this.settingsData.title
    );
  }

  setTabUgovor(tab: RealizacijaEnum) {
    this.activeTab = tab;
  }

  valueChanged(event) {
    switch(this.activeTab) {
      case RealizacijaEnum.UkupnaRealizacija: {
      }
      break;
      case RealizacijaEnum.RealizacijaUgovora: {
        if(event.newValue) {
          this.ugovorReport.BrojUgovora = event.newValue.BrojUgovora;
          this.ugovorReport.KlijentNaUgovoru = event.newValue.Klijent.NazivImePrezime;
          this.ugovorReport.DatumOd = event.newValue.DatumKreiranja;
          this.ugovorReport.DatumDo = event.newValue.DatumIsteka;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaKlijenta: {
      }
      break;
      case RealizacijaEnum.RealizacijaPodugovora: {
        const podugovor = this.podugovorFieldStructure.fieldList.find(
          f => f.fieldKey === 'Podugovor'
        );
        if (event.newValue) {
          if (event.fieldMap.fieldKey === 'Ugovor') {
            this.togglePodugovor(true);
            podugovor.lookupInitFilter = [
              { name: 'ugovorId', value: this.podugovorReport.Ugovor.Id },
            ];
          }
          if(this.podugovorReport.Podugovor) {
            this.podugovorReport.BrojUgovora = this.podugovorReport.Ugovor.BrojUgovora;
            this.podugovorReport.BrojPodugovora = event.newValue.BrojPodugovora;
            this.podugovorReport.KlijentNaPodugovoru = event.newValue.Klijent.NazivImePrezime;
            this.podugovorReport.DatumOd = event.newValue.DatumKreiranja;
            this.podugovorReport.DatumDo = event.newValue.DatumIsteka;
          }
          if(event.newValue.BrojUgovora && event.oldValue) {
            if(this.podugovorReport.Ugovor.BrojUgovora !== event.oldValue.BrojUgovora) {
              this.podugovorReport.Podugovor = null;
              this.podugovorReport.DatumOd = '';
              this.podugovorReport.DatumDo = '';
            }
          }
        }
      }
      break;
    }
  }

  omitColumnsPodugovor() {
    const podugovor = this.fieldStructure.fieldList.find(
      f => f.fieldKey === 'Podugovor'
    );
  }

  togglePodugovor(enable: boolean) {
    const podugovor = this.podugovorFieldStructure.fieldList.find(
      f => f.fieldKey === 'Podugovor'
    );
    podugovor.additable = enable;
    podugovor.editable = enable;
  }

  private paramString(
    filter: string,
    allowedKeys: string[],
    first: boolean,
    param: string
  ) {
    if (first) {
      if (allowedKeys.some(allowedKey => param.startsWith(allowedKey))) {
        filter = `?${param}`;
      }
    } else {
      if (allowedKeys.some(allowedKey => param.startsWith(allowedKey))) {
        if (filter) {
          filter += `&${param}`;
        } else {
          filter = `?${param}`;
        }
      }
    }

    return filter;
  }

  checkDateInterval() {
    let imaDatum = false;
    switch(this.activeTab) {
      case RealizacijaEnum.UkupnaRealizacija: {
        if (this.ukupnoReport.DatumOd && this.ukupnoReport.DatumDo) {
          imaDatum = this.ukupnoReport.DatumDo < this.ukupnoReport.DatumOd;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaUgovora: {
        if (this.ugovorReport.DatumOd && this.ugovorReport.DatumDo) {
          imaDatum = this.ugovorReport.DatumDo < this.ugovorReport.DatumOd;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaKlijenta: {
        if (this.klijentReport.DatumOd && this.klijentReport.DatumDo) {
          imaDatum = this.klijentReport.DatumDo < this.klijentReport.DatumOd;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaPodugovora: {
        if (this.podugovorReport.DatumOd && this.podugovorReport.DatumDo) {
          imaDatum = this.podugovorReport.DatumDo < this.podugovorReport.DatumOd;
        }
      }
      break;
    }

    // if (this.report.DatumOd && this.report.DatumDo) {
    //   return this.report.DatumDo < this.report.DatumOd;
    // }

    return imaDatum;
  }

  checkForEmptyFields() {
    let imaDatum = false;
    switch(this.activeTab) {
      case RealizacijaEnum.UkupnaRealizacija: {
        if (!this.ukupnoReport.DatumOd || !this.ukupnoReport.DatumDo) {
          imaDatum = true;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaUgovora: {
        if (!this.ugovorReport.DatumOd || !this.ugovorReport.DatumDo) {
          imaDatum = true;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaKlijenta: {
        if (!this.klijentReport.DatumOd || !this.klijentReport.DatumDo) {
          imaDatum = true;
        }
      }
      break;
      case RealizacijaEnum.RealizacijaPodugovora: {
        if (!this.podugovorReport.DatumOd || !this.podugovorReport.DatumDo) {
          imaDatum = true;
        }
      }
      break;
    }

    // if (!this.report.DatumOd || !this.report.DatumDo) {
    //   return true;
    // }

    return imaDatum;
  }

  filter() {
    switch(this.activeTab) {
      case RealizacijaEnum.UkupnaRealizacija: {
        if (this.checkForEmptyFields()) {
          return this.notificationService.notyError(
            'Datum Od i Datum Do su obavezni!'
          );
        }
    
        if (this.checkDateInterval()) {
          return this.notificationService.notyError(
            'Datum Od ne sme biti veći od polja Datum Do!'
          );
        }
      }
      break;
      case RealizacijaEnum.RealizacijaUgovora: {
        if(!this.ugovorReport.Ugovor) {
          return this.notificationService.notyError(
            'Ugovor je obavezan!'
          );
        }
      }
      break;
      case RealizacijaEnum.RealizacijaKlijenta: {
        if(!this.klijentReport.Klijent) {
          return this.notificationService.notyError(
            'Klijent je obavezan!'
          );
        }

        if (this.checkForEmptyFields()) {
          return this.notificationService.notyError(
            'Datum Od i Datum Do su obavezni!'
          );
        }
    
        if (this.checkDateInterval()) {
          return this.notificationService.notyError(
            'Datum Od ne sme biti veći od polja Datum Do!'
          );
        }
      }
      break;
      case RealizacijaEnum.RealizacijaPodugovora: {
        if(this.podugovorReport.Podugovor === null || this.podugovorReport.Podugovor === undefined) {
          //if(this.podugovorReport.Ugovor === null || this.podugovorReport.Ugovor === undefined) {
            return this.notificationService.notyError(
              'Ugovor i podugovor su obavezni!'
            );
          //}
        }
      }
    }

    setTimeout(() => {
      this._spinner.show();
    });

    const params = [];
    let filterUkupna = '';
    let filterUgovor = '';
    let filterKlijent = '';
    let filterPodugovor = '';

    switch(this.activeTab) {
      case RealizacijaEnum.UkupnaRealizacija: {
        if (this.ukupnoReport.DatumOd && this.ukupnoReport.DatumDo) {
          params.push(`odDatuma=${moment(this.ukupnoReport.DatumOd).format('YYYY-MM-DD')}`);
          params.push(`doDatuma=${moment(this.ukupnoReport.DatumDo).format('YYYY-MM-DD')}`);
        }

        params.forEach((param, index) => {
          if (index === 0) {
            filterUkupna = this.paramString(
              filterUkupna,
              ['odDatuma', 'doDatuma'],
              true,
              param
            );
          } else {
            filterUkupna = this.paramString(
              filterUkupna,
              ['odDatuma', 'doDatuma'],
              filterUkupna === null,
              param
            );
          }
        });

        const payloadUkupna = this.rtsBackendService.getRequestPayload(
          FormCode.MSBUDZET_IZVUK,
          FormName.RealizacijaUgovora,
          EndpointTypes.GetSingleEntity,
          filterUkupna === '' ? null : filterUkupna,
          null,
          null
        );

        this.budzetService.getIzvestaj(payloadUkupna).subscribe(
          response => {
            this._spinner.hide();
            // this.ugovoreniBudzetRSD = response.ServiceData.PriliviRSD
            //   ? parseInt(`${response.ServiceData.PriliviRSD}`, 0)
            //   : 0;
            // this.rezervacijeRSD = response.ServiceData.RezervisanoRSD
            //   ? parseInt(`${response.ServiceData.RezervisanoRSD}`, 0)
            //   : 0;
            this.realizacijeRSD = response.ServiceData.RealizovanoRSD;
              // ? parseInt(`${response.ServiceData.RealizovanoRSD}`, 10)
              // : 0;
            // this.ugovoreniBudzetEUR = response.ServiceData.PriliviEUR
            //   ? parseInt(`${response.ServiceData.PriliviEUR}`, 0)
            //   : 0;
            // this.rezervacijeEUR = response.ServiceData.RezervisanoEUR
            //   ? parseInt(`${response.ServiceData.RezervisanoEUR}`, 0)
            //   : 0;
            this.realizacijeEUR = response.ServiceData.RealizovanoEUR;
              // ? parseInt(`${response.ServiceData.RealizovanoEUR}`, 10)
              // : 0;

            this.excelEntity.RealizacijaUkupno = null;
            this.excelEntity.RealizacijaUkupno = {
              DatumOd : this.ukupnoReport.DatumOd,
              DatumDo : this.ukupnoReport.DatumDo,
              Valute : this.currenciesUkupno,
              //Rezervisano : [this.rezervacijeRSD, this.rezervacijeEUR],
              Realizovano : [this.ukupnoReport.DatumOd, this.ukupnoReport.DatumDo, this.realizacijeRSD, this.realizacijeEUR]
            };
          },
          () => {
            this._spinner.hide();
            this.notificationService.openNoty(
              'Desila se greška pri dohvatanju izveštaja.'
            );
          }
        );
      }
      break;
      case RealizacijaEnum.RealizacijaUgovora: {
        if (this.ugovorReport.DatumOd && this.ugovorReport.DatumDo) {
          params.push(`odDatuma=${moment(this.ugovorReport.DatumOd).format('YYYY-MM-DD')}`);
          params.push(`doDatuma=${moment(this.ugovorReport.DatumDo).format('YYYY-MM-DD')}`);
        }

        if (this.ugovorReport.Ugovor && this.ugovorReport.Ugovor.Id) {
          params.push(`ugovorId=${this.ugovorReport.Ugovor.Id}`);
          params.push(`valutaId=${this.ugovorReport.Ugovor.ValutaId}`);
          this.realizacijaPoUgovoruTitle = `Realizacija po ugovoru ${this.ugovorReport.Ugovor.BrojUgovora}`;
        } else {
          this.realizacijaPoUgovoruTitle = 'Izaberite ugovor za prikaz';
        }

        params.forEach((param, index) => {
          if (index === 0) {
            filterUgovor = this.paramString(
              filterUgovor,
              ['ugovorId', 'valutaId', 'odDatuma', 'doDatuma'],
              true,
              param
            );
          } else {
            filterUgovor = this.paramString(
              filterUgovor,
              ['ugovorId', 'valutaId', 'odDatuma', 'doDatuma'],
              filterUgovor === null,
              param
            );
          }
        });

        const payloadUgovor = this.rtsBackendService.getRequestPayload(
          FormCode.MSBUDZET_IZVUGO,
          FormName.RealizacijaUgovora,
          EndpointTypes.GetSingleEntity,
          filterUgovor === '' ? null : filterUgovor,
          null,
          null
        );

        if (this.ugovorReport.Ugovor && this.ugovorReport.Ugovor.Id) {
          this.budzetService.getIzvestaj(payloadUgovor).subscribe(
            response => {
              this._spinner.hide();
              this.resetChartUgovor();
    
              // Rezervisane
              // this.barChartDataUgovor[0].data = response.ServiceData.RezervisaneStavkeBudzeta.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              // this.lineChartDataUgovor[0].data = response.ServiceData.RezervisaneStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              // this.barChartDataUgovor[1].data = response.ServiceData.RezervisaneStavkeBudzeta.map(
              //   ({ IznosEUR }) => IznosEUR
              // );
              // this.lineChartDataUgovor[1].data = response.ServiceData.RezervisaneStavkeBudzetaKumulativno.map(
              //   ({ IznosEUR }) => IznosEUR
              // );
              // Realizovane
              this.barChartDataUgovor[1].data = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ IznosRSD }) => IznosRSD
              );
              this.lineChartDataUgovor[1].data = response.ServiceData.RealizovaneStavkeBudzetaKumulativno.map(
                ({ IznosRSD }) => IznosRSD
              );
              this.barChartDataUgovor[2].data = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ IznosEUR }) => IznosEUR
              );
              this.lineChartDataUgovor[2].data = response.ServiceData.RealizovaneStavkeBudzetaKumulativno.map(
                ({ IznosEUR }) => IznosEUR
              );
    
              // Priliv
              // this.lineChartDataUgovor[2].data = response.ServiceData.PrilivStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              this.monthsLabelsUgovor = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ MesecLabela }) => MesecLabela
              );

              this.excelEntity.RealizacijaUgovora = null;
              this.excelEntity.RealizacijaUgovora = {
                DatumOd : this.ugovorReport.DatumOd,
                DatumDo : this.ugovorReport.DatumDo,
                BrojUgovora : this.ugovorReport.Ugovor.BrojUgovora,
                KlijentNaUgovoru : this.ugovorReport.Ugovor.Klijent.NazivImePrezime,
                Meseci : this.monthsLabelsUgovor,
                //RezervisanoRSD : this.barChartDataUgovor[0].data,
                RealizovanoRSD : this.barChartDataUgovor[1].data,
                RealizovanoEUR : this.barChartDataUgovor[2].data,
                //RezervisanoKumulativnoRSD : this.lineChartDataUgovor[0].data,
                RealizovanoKumulativnoRSD : this.lineChartDataUgovor[1].data,
                RealizovanoKumulativnoEUR : this.lineChartDataUgovor[2].data
              };
            },
            () => {
              this._spinner.hide();
              this.notificationService.openNoty(
                'Desila se greška pri dohvatanju izveštaja.'
              );
            }
          );
        } else {
          this.resetChartUgovor();
        }

      }
      break;
      case RealizacijaEnum.RealizacijaKlijenta: {
        if (this.klijentReport.DatumOd && this.klijentReport.DatumDo) {
          params.push(`odDatuma=${moment(this.klijentReport.DatumOd).format('YYYY-MM-DD')}`);
          params.push(`doDatuma=${moment(this.klijentReport.DatumDo).format('YYYY-MM-DD')}`);
        }

        if (this.klijentReport.Klijent && this.klijentReport.Klijent.Id) {
          params.push(`klijentBudzetId=${this.klijentReport.Klijent.Id}`);
          this.realizacijaPoKlijentuTitle = `Realizacija po klijentu ${this.klijentReport.Klijent.NazivImePrezime}`;
        } else {
          this.realizacijaPoKlijentuTitle = 'Izaberite klijenta za prikaz';
        }

        params.forEach((param, index) => {
          if (index === 0) {
            filterKlijent = this.paramString(
              filterKlijent,
              ['klijentBudzetId', 'odDatuma', 'doDatuma'],
              true,
              param
            );
          } else {
            filterKlijent = this.paramString(
              filterKlijent,
              ['klijentBudzetId', 'odDatuma', 'doDatuma'],
              filterKlijent === null,
              param
            );
          }
        });          

        const payloadKlijent = this.rtsBackendService.getRequestPayload(
          FormCode.MSBUDZET_IZVKLI,
          FormName.RealizacijaUgovora,
          EndpointTypes.GetSingleEntity,
          filterKlijent === '' ? null : filterKlijent,
          null,
          null
        );

        if (this.klijentReport.Klijent && this.klijentReport.Klijent.Id) {
          this.budzetService.getIzvestaj(payloadKlijent).subscribe(
            response => {
              this._spinner.hide();
              this.resetChartKlijent();
              const ugovori = response.ServiceData.RealizovaneStavkeBudzeta.filter(
                x => x.BrojUgovora !== null
              ).map(({ BrojUgovora }) => BrojUgovora);

              function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
              }
              
              let uniqueUgovori = ugovori.filter(onlyUnique);

              for(let i = uniqueUgovori.length - 1; i > -1; i--) {
                this.lineChartDataKlijent.unshift({
                  dataRSD: [],
                  dataEUR: [],
                  label: uniqueUgovori[i],
                  fill: false,
                  lineTension: 0,
                });
              }

              let sviMeseciSaDuplikatima = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ MesecLabela }) => MesecLabela
              );

              let sviBrojeviMeseciSaDuplikatima = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ Mesec }) => Mesec
              );

              let uniqueMeseci = sviMeseciSaDuplikatima.filter(onlyUnique);
              let uniqueBrojeviMeseci = sviBrojeviMeseciSaDuplikatima.filter(onlyUnique);
           
              for(let i = 0; i < this.lineChartDataKlijent.length; i++) {
                let brojUgovora = this.lineChartDataKlijent[i].label;
                let realizovaneStavkePoUgovoru = response.ServiceData.RealizovaneStavkeBudzeta.filter(function (el) {
                  return brojUgovora == el.BrojUgovora
                });

                for(let k = 0; k < uniqueMeseci.length; k++) {
                  if(k > realizovaneStavkePoUgovoru.length - 1) {
                    realizovaneStavkePoUgovoru.push({
                      BrojUgovora: realizovaneStavkePoUgovoru[k - 1].BrojUgovora,
                      Godina: realizovaneStavkePoUgovoru[k - 1].Godina,
                      IznosEUR: 0,
                      IznosRSD: 0,
                      Mesec: uniqueBrojeviMeseci[k],
                      MesecLabela: uniqueMeseci[k]
                    });
                  }
                  if(realizovaneStavkePoUgovoru[k].MesecLabela !== null && uniqueMeseci[k] == realizovaneStavkePoUgovoru[k].MesecLabela) {
                    continue;
                  }
                  else {
                    if(uniqueBrojeviMeseci[k] < realizovaneStavkePoUgovoru[k].Mesec) {
                      realizovaneStavkePoUgovoru.unshift({
                        BrojUgovora: realizovaneStavkePoUgovoru[k].BrojUgovora,
                        Godina: realizovaneStavkePoUgovoru[k].Godina,
                        IznosEUR: 0,
                        IznosRSD: 0,
                        Mesec: uniqueBrojeviMeseci[k],
                        MesecLabela: uniqueMeseci[k]
                      });
                    }
                    else {
                      realizovaneStavkePoUgovoru.push({
                        BrojUgovora: realizovaneStavkePoUgovoru[k].BrojUgovora,
                        Godina: realizovaneStavkePoUgovoru[k].Godina,
                        IznosEUR: 0,
                        IznosRSD: 0,
                        Mesec: uniqueBrojeviMeseci[k],
                        MesecLabela: uniqueMeseci[k]
                      });
                    }
                  }
                }

                for(let j = 0; j < realizovaneStavkePoUgovoru.length; j++) {
                  this.lineChartDataKlijent[i].dataRSD.push(realizovaneStavkePoUgovoru[j].IznosRSD);
                  this.lineChartDataKlijent[i].dataEUR.push(realizovaneStavkePoUgovoru[j].IznosEUR);
                }
              }

              let brojMeseci = uniqueMeseci.length;
              for(let i = 0; i < this.lineChartDataKlijent.length; i++) {
                for(let j = 0; j < brojMeseci; j++) {
                  if(this.lineChartDataKlijent[i].dataRSD[j] === null || this.lineChartDataKlijent[i].dataRSD[j] === undefined) {
                    this.lineChartDataKlijent[i].dataRSD.push(0);
                  }
                  if(this.lineChartDataKlijent[i].dataEUR[j] === null || this.lineChartDataKlijent[i].dataEUR[j] === undefined) {
                    this.lineChartDataKlijent[i].dataEUR.push(0);
                  }
                }
              }

              let brojMeseciZaRacunanje = response.ServiceData.RealizovaneStavkeBudzeta.length;
              let kumulativSvihUgovoraRSD = 0;
              let kumulativSvihUgovoraEUR = 0;
              this.realizacijaUkupnoKumulativno[0].data = [];
              this.realizacijaUkupnoKumulativno[1].data = [];
              for(let i = 0; i < brojMeseciZaRacunanje; i++) {
                for(let j = 0; j < this.lineChartDataKlijent.length; j++) {
                  kumulativSvihUgovoraRSD += this.lineChartDataKlijent[j].dataRSD[i];
                  kumulativSvihUgovoraEUR += this.lineChartDataKlijent[j].dataEUR[i];
                  this.realizacijaUkupnoKumulativno[0].data[i] = kumulativSvihUgovoraRSD;
                  this.realizacijaUkupnoKumulativno[1].data[i] = kumulativSvihUgovoraEUR;
                  //this.barChartDataKlijent[0].data[i] = kumulativSvihUgovora;
                }
              }

              // this.realizacijaUkupnoKumulativno[0].data = response.ServiceData.RealizovaneStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );

              this.monthsLabelsKlijent = uniqueMeseci;
              //this.lineChartDataKlijent[1].data = response.ServiceData.PrilivStavkeBudzetaKumulativno.map(
              //  ({ IznosRSD }) => IznosRSD
              //);

              // this.realizacijaUkupnoKumulativno[1].data = response.ServiceData.PrilivStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );

              this.realizacijaPoUgovorimaRSD = [];
              this.realizacijaPoUgovorimaEUR = [];
              for(let i = 0; i < this.lineChartDataKlijent.length; i++) {
                this.realizacijaPoUgovorimaRSD.push({
                  key : this.lineChartDataKlijent[i].label,
                  value : this.lineChartDataKlijent[i].dataRSD
                })
                this.realizacijaPoUgovorimaEUR.push({
                  key : this.lineChartDataKlijent[i].label,
                  value : this.lineChartDataKlijent[i].dataEUR
                })
              }
              
              if(this.realizacijaUkupnoKumulativno[0].data.length === 0 || this.realizacijaUkupnoKumulativno[1].data.length === 0) {
                this.realizacijaUkupnoKumulativno[0].data = [this.monthsLabelsKlijent.length];
                this.realizacijaUkupnoKumulativno[1].data = [this.monthsLabelsKlijent.length];

                for(let i = 0; i < this.monthsLabelsKlijent.length; i++) {
                  this.realizacijaUkupnoKumulativno[0].data[i] = 0;
                  this.realizacijaUkupnoKumulativno[1].data[i] = 0;
                }
              }

              this.excelEntity.RealizacijePoKlijentu = null;
              this.excelEntity.RealizacijePoKlijentu = {
                Klijent : this.klijentReport.Klijent.NazivImePrezime,
                DatumOd : this.klijentReport.DatumOd,
                DatumDo : this.klijentReport.DatumDo,
                Meseci : this.monthsLabelsKlijent,
                RealizacijaPoUgovorimaRSD : this.realizacijaPoUgovorimaRSD,
                RealizacijaPoUgovorimaEUR : this.realizacijaPoUgovorimaEUR,
                RealizovanoKumulativnoRSD : this.realizacijaUkupnoKumulativno[0].data,
                RealizovanoKumulativnoEUR : this.realizacijaUkupnoKumulativno[1].data
              };
            },
            () => {
              this._spinner.hide();
              this.notificationService.openNoty(
                'Desila se greška pri dohvatanju izveštaja.'
              );
            }
          );
        } else {
          this.resetChartKlijent();
        }

      }
      break;
      case RealizacijaEnum.RealizacijaPodugovora: {
        if (this.podugovorReport.DatumOd && this.podugovorReport.DatumDo) {
          params.push(`odDatuma=${moment(this.podugovorReport.DatumOd).format('YYYY-MM-DD')}`);
          params.push(`doDatuma=${moment(this.podugovorReport.DatumDo).format('YYYY-MM-DD')}`);
        }

        if (this.podugovorReport.Podugovor && this.podugovorReport.Podugovor.Id) {
          params.push(`podugovorId=${this.podugovorReport.Podugovor.Id}`);
          params.push(`tipUgovoraId=${this.podugovorReport.Podugovor.TipUgovoraId}`);
          params.push(`valutaId=${this.podugovorReport.Podugovor.ValutaId}`)
          this.realizacijaPoPodugovoruTitle = `Realizacija po podugovoru ${this.podugovorReport.Podugovor.BrojPodugovora}`;
        } else {
          this.realizacijaPoPodugovoruTitle = 'Izaberite podugovor za prikaz';
        }

        params.forEach((param, index) => {
          if (index === 0) {
            filterPodugovor = this.paramString(
              filterPodugovor,
              ['ugovorId', 'podugovorId', 'tipUgovoraId', 'valutaId', 'odDatuma', 'doDatuma'],
              true,
              param
            );
          } else {
            filterPodugovor = this.paramString(
              filterPodugovor,
              ['ugovorId', 'podugovorId', 'tipUgovoraId', 'valutaId', 'odDatuma', 'doDatuma'],
              filterPodugovor === null,
              param
            );
          }
        });

        const payloadPodugovor = this.rtsBackendService.getRequestPayload(
          FormCode.MSBUDZET_IZVUGO,
          FormName.RealizacijaUgovora,
          EndpointTypes.GetSingleEntity,
          filterPodugovor === '' ? null : filterPodugovor,
          null,
          null
        );

        if (this.podugovorReport.Podugovor && this.podugovorReport.Podugovor.Id) {
          this.budzetService.getIzvestaj(payloadPodugovor).subscribe(
            response => {
              this._spinner.hide();
              this.resetChartPodugovor();
    
              // Rezervisane
              // this.barChartDataPodugovor[0].data = response.ServiceData.RezervisaneStavkeBudzeta.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              // this.lineChartDataPodugovor[0].data = response.ServiceData.RezervisaneStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              // this.barChartDataPodugovor[1].data = response.ServiceData.RezervisaneStavkeBudzeta.map(
              //   ({ IznosEUR }) => IznosEUR
              // );
              // this.barChartDataPodugovor[1].data = response.ServiceData.RezervisaneStavkeBudzetaKumulativno.map(
              //   ({ IznosEUR }) => IznosEUR
              // );
              // Realizovane
              this.barChartDataPodugovor[1].data = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ IznosRSD }) => IznosRSD
              );
              this.lineChartDataPodugovor[1].data = response.ServiceData.RealizovaneStavkeBudzetaKumulativno.map(
                ({ IznosRSD }) => IznosRSD
              );
              this.barChartDataPodugovor[2].data = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ IznosEUR }) => IznosEUR
              );
              this.lineChartDataPodugovor[2].data = response.ServiceData.RealizovaneStavkeBudzetaKumulativno.map(
                ({ IznosEUR }) => IznosEUR
              );
    
              // Priliv
              // this.lineChartDataPodugovor[2].data = response.ServiceData.PrilivStavkeBudzetaKumulativno.map(
              //   ({ IznosRSD }) => IznosRSD
              // );
              this.monthsLabelsPodugovor = response.ServiceData.RealizovaneStavkeBudzeta.map(
                ({ MesecLabela }) => MesecLabela
              );

              this.excelEntity.RealizacijaPodugovora = null;
              this.excelEntity.RealizacijaPodugovora = {
                DatumOd : this.podugovorReport.DatumOd,
                DatumDo : this.podugovorReport.DatumDo,
                BrojUgovora : this.podugovorReport.Ugovor.BrojUgovora,
                BrojPodugovora : this.podugovorReport.Podugovor.BrojPodugovora,
                KlijentNaPodugovoru : this.podugovorReport.Podugovor.Klijent.NazivImePrezime,
                Meseci : this.monthsLabelsPodugovor,
                //RezervisanoRSD : this.barChartDataPodugovor[0].data,
                RealizovanoRSD : this.barChartDataPodugovor[1].data,
                RealizovanoEUR : this.barChartDataPodugovor[2].data,
                //RezervisanoKumulativnoRSD : this.lineChartDataPodugovor[0].data,
                RealizovanoKumulativnoRSD : this.lineChartDataPodugovor[1].data,
                RealizovanoKumulativnoEUR : this.lineChartDataPodugovor[2].data
              };
            },
            () => {
              this._spinner.hide();
              this.notificationService.openNoty(
                'Desila se greška pri dohvatanju izveštaja.'
              );
            }
          );
        } else {
          this.resetChartPodugovor();
        }

      }
      break;
    }
  }

  public generisiExcelDokument() {
    if(this.excelEntity.RealizacijaUkupno === null &&
       this.excelEntity.RealizacijaUgovora === null &&
       this.excelEntity.RealizacijePoKlijentu === null &&
       this.excelEntity.RealizacijaPodugovora === null) {
        this.notificationService.openNoty('Morate učitati podatke bar sa jedne kartice da biste mogli da generišete Excel dokument.');
        return;
       }

    this._spinner.show();
    const request: RGatewayRequest = this.reportService.getPayload(
      null,
      this.excelEntity,
      FormCode.MSBUDZET_EXCEL,
      ReportNameEnum.Realizacija,
      EndpointTypeEnum.Xls,
      RequestTypeEnum.Post
    );

    this.reportService.exportToDocument(request).subscribe(data => {
      const formattedDate: string = `${moment(new Date()).format(
        'YYYY-MM-DD_HH:mm'
      )}`.replace(
        `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
        '-'
      );
      const fileName = `Realizacija_${formattedDate}`;
      this._spinner.hide();
      ReportService.downloadBlob(data, MimeFileType.Xlsx, fileName);
    });
  }

  private addKumulativIfEmpty(data: any[], kumilativ) {
    if (data.length === 0) {
      for (let i = 0; i < 12; i++) {
        data.push(kumilativ);
      }
    }
  }

  private sortBy(data: any[]) {
    data.sort((a, b) => {
      const mesecA = parseInt(a.Mesec, 0),
        mesecB = parseInt(b.Mesec, 0);
      if (mesecA < mesecB) {
        return -1;
      }
      if (mesecA > mesecB) {
        return 1;
      }

      return 0;
    });
  }

  private groupBy(data, property) {
    return data.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);

      return acc;
    }, {});
  }

  private calculateCharts(
    stavka,
    poslednjaStavka,
    lineChartData,
    barChartData,
    last
  ) {
    if (stavka) {
      const iznosRSDBarChart = parseInt(`${stavka.IznosRSD}`, 0);
      let iznosRSDLineChart = parseInt(`${stavka.IznosRSD}`, 0);
      if (poslednjaStavka.Mesec === 0) {
        if (parseInt(`${stavka.Mesec}`, 0) === this.fromMonth) {
          iznosRSDLineChart =
            parseInt(`${poslednjaStavka.IznosRSD}`, 0) +
            parseInt(`${stavka.IznosRSD}`, 0);
        } else {
          lineChartData.push(parseInt(`${poslednjaStavka.IznosRSD}`, 0));
          poslednjaStavka.Mesec = this.fromMonth;
        }
      }
      let diff =
        parseInt(`${stavka.Mesec}`, 0) -
        parseInt(`${poslednjaStavka.Mesec}`, 0) -
        1;
      if (lineChartData.length !== 0 && diff !== 0) {
        for (let i = 0; i < diff; i++) {
          if (barChartData) {
            barChartData.push(0);
          }
          if (lineChartData.length === 0) {
            lineChartData.push(0);
            poslednjaStavka.IznosRSD = 0;
          } else {
            lineChartData.push(parseInt(`${poslednjaStavka.IznosRSD}`, 0));
          }
        }
      }
      if (barChartData) {
        barChartData.push(iznosRSDBarChart);
      }
      lineChartData.push(
        parseInt(`${poslednjaStavka.IznosRSD}`, 0) + iznosRSDLineChart
      );
      poslednjaStavka.IznosRSD =
        parseInt(`${poslednjaStavka.IznosRSD}`, 0) + iznosRSDLineChart;

      // If last
      if (last) {
        // Fill end
        diff = 12 - parseInt(`${stavka.Mesec}`, 0);
        if (last && diff !== 0) {
          for (let i = 0; i < diff; i++) {
            if (barChartData) {
              barChartData.push(0);
            }
            lineChartData.push(parseInt(`${poslednjaStavka.IznosRSD}`, 0));
          }
        }
        // Fill beginning
        let len = 12;
        if (barChartData) {
          len = 12 - barChartData.length;
          for (let i = 0; i < len; i++) {
            barChartData.unshift(0);
          }
        }
        len = 12 - lineChartData.length;
        for (let i = 0; i < len; i++) {
          lineChartData.unshift(parseInt(`${poslednjaStavka.IznosRSD}`, 0));
        }
      }
      poslednjaStavka.Mesec = stavka.Mesec;
    }
  }

  private resetChartUgovor() {
    this.lineChartDataUgovor = [
      {
        data: [],
        label: 'Rezervacije kumulativno RSD',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Rezervacije kumulativno EUR',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Realizacija kumulativno RSD',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Realizacija kumulativno EUR',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Budžet po ugovoru',
        borderColor: 'red',
        fill: false,
        borderDash: [5, 5],
        lineTension: 0,
      },
    ];
    this.barChartDataUgovor = [
      { data: [], label: 'Rezervacije RSD', borderWidth: 1 },
      { data: [], label: 'Realizacija RSD', borderWidth: 1 },
      { data: [], label: 'Realizacija EUR', borderWidth: 1 },
    ];
  }

  private resetChartPodugovor() {
    this.lineChartDataPodugovor = [
      {
        data: [],
        label: 'Rezervacije kumulativno RSD',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Realizacija kumulativno RSD',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Realizacija kumulativno EUR',
        fill: false,
        lineTension: 0,
      },
      {
        data: [],
        label: 'Budžet po podugovoru',
        borderColor: 'red',
        fill: false,
        borderDash: [5, 5],
        lineTension: 0,
      },
    ];
    this.barChartDataPodugovor = [
      { data: [], label: 'Rezervacije RSD', borderWidth: 1 },
      { data: [], label: 'Realizacija RSD', borderWidth: 1 },
      { data: [], label: 'Realizacija EUR', borderWidth: 1 },
    ];
  }

  private resetChartKlijent() {
    this.lineChartDataKlijent = [
      // {
      //   data: [],
      //   label: 'Realizacija kumulativno',
      //   fill: false,
      //   lineTension: 0,
      // },
      // {
      //   data: [],
      //   label: 'Budžet po ugovorima',
      //   fill: false,
      //   borderColor: 'red',
      //   borderDash: [5, 5],
      //   lineTension: 0,
      // },
    ];
    this.barChartDataKlijent = [
      { data: [], label: 'Realizovano po ugovoru', borderWidth: 1 },
    ];
  }

  getPercentUgovoreniBudzetRSD(
    ugovoreniBudzetRSD: number,
    rezervacijeRSD: number,
    realaizacijeRSD: number
  ) {
    const percentages = {
      ugovoreniBudzetRSD: 0,
      rezervacijeRSD: 0,
      realaizacijeRSD: 0,
    };
    if (
      ugovoreniBudzetRSD > rezervacijeRSD &&
      ugovoreniBudzetRSD > realaizacijeRSD
    ) {
      percentages.realaizacijeRSD =
        (realaizacijeRSD / ugovoreniBudzetRSD) * 100;
      percentages.rezervacijeRSD = (rezervacijeRSD / ugovoreniBudzetRSD) * 100;
      percentages.ugovoreniBudzetRSD = 100;
    }
    if (
      rezervacijeRSD > ugovoreniBudzetRSD &&
      rezervacijeRSD > realaizacijeRSD
    ) {
      percentages.realaizacijeRSD = (realaizacijeRSD / rezervacijeRSD) * 100;
      percentages.ugovoreniBudzetRSD =
        (ugovoreniBudzetRSD / rezervacijeRSD) * 100;
      percentages.rezervacijeRSD = 100;
    }
    if (
      realaizacijeRSD > ugovoreniBudzetRSD &&
      realaizacijeRSD > rezervacijeRSD
    ) {
      percentages.rezervacijeRSD = (rezervacijeRSD / realaizacijeRSD) * 100;
      percentages.ugovoreniBudzetRSD =
        (ugovoreniBudzetRSD / realaizacijeRSD) * 100;
      percentages.realaizacijeRSD = 100;
    }

    return percentages;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/realizacija-ugovora/realizacija-ugovora.component.ts